export default __webpack_public_path__ + "static/media/CarImages.SeltosMedium1.c72b5a24.jpg";